import { render, staticRenderFns } from "./ModalOrganEdit.vue?vue&type=template&id=0ea3d5b0&scoped=true"
import script from "./ModalOrganEdit.vue?vue&type=script&lang=js"
export * from "./ModalOrganEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalOrganEdit.vue?vue&type=style&index=0&id=0ea3d5b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea3d5b0",
  null
  
)

export default component.exports